import React, { useState, useEffect } from "react";
import { styled } from "baseui";
import ModelerParametersView from "./ModelerParametersView";
import ModelerExecuteMainHeaderView from "./ModelerExecuteMainHeaderView";
import * as AppConstants from "../../constants/AppConstants";
import { Textarea } from "baseui/textarea";
import { FormControl } from "baseui/form-control";
import { FlexGrid, FlexGridItem } from "baseui/flex-grid";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { fetchModelRunById } from "../../redux/model-run/ModelRunThunk";
import {
  setselectedModelRun,
  updateselectedModelRun,
} from "../../redux/model-run/ModelRunActions";
import { useParams, useLocation } from "react-router-dom";
import useToaster from "../../hooks/useToaster";
import LoadingOverlay from "../../components/loading-overlay/LoadingOverlayComponent";
import useRouteParams from "../../hooks/useRouteParams";
import { Notification, KIND } from "baseui/notification";
const MainContainer = styled(FlexGrid, ({ $theme }) => ({
  maxWidth: "1200px",
  padding: AppConstants.APP_MAIN_PADDING,
  margin: "10px auto",
}));

const HeadearArea = styled(FlexGridItem, ({ $theme }) => ({
  // height: "100px",
  borderBottom: `${$theme.colors.primary} solid`,
}));
const ParameterArea = styled(FlexGridItem, ({ $theme }) => ({
  borderBottom: `${$theme.colors.primary} solid`,
  minHeight: "calc(75vh - 200px)",
}));

const FooterArea = styled(FlexGridItem, ({ $theme }) => ({
  height: "120px",
}));

function ModelerExecuteHomeView(props) {
  const location = useLocation();
  const { t } = useTranslation("modeler");
  const { pathParams, searchParams, searchPart } = useRouteParams();
  const [modelRunId, setModelRunId] = useState(searchParams["runId"]);
  const [selectedModelRun, setselectedModelRun] = useState(
    props.selectedModelRun
  );
  const [modelRunNotes, setModelRunNotes] = useState(
    props.selectedModelRun?.runNotes
  );

  const [modelRunGenerated, setModelRunGenerated] = useState(
    props.selectedModelRun?.generated
  );

  useToaster(props.createErrorMessage);
  useToaster(props.fetchErrorMessage);

  useEffect(() => {
    const runId = searchParams["runId"];
    if (runId && runId !== props.activeModelRunId) {
      setModelRunId(runId);
      props.onFetchModelRunById(runId);
    }
  }, [location.search]);

  useEffect(() => {
    setselectedModelRun(props.selectedModelRun);
    setModelRunNotes(props.selectedModelRun?.runNotes);
    setModelRunGenerated(props.selectedModelRun?.generated);
  }, [props.selectedModelRun]);

  const onInputValueChange = (groupName, itemName, itemValue) => {
    let modelRun = { ...selectedModelRun };
    let idx = (modelRun?.inputValues || []).findIndex(
      (iv) => iv.itemName === itemName
    );
    if (idx !== -1) {
      modelRun.inputValues[idx].itemValue = itemValue;
      props.onselectedModelRunUpdate(modelRun);
    }
  };
  return (
    <MainContainer
      flexGridColumnCount={1}
      flexDirection="column"
      flexGridColumnGap="scale800"
      flexGridRowGap="scale800"
    >
      <LoadingOverlay
        isLoading={props.createInProgress || props.fetchInProgress}
      />
      <HeadearArea>
        <ModelerExecuteMainHeaderView disabled={!modelRunId} />
      </HeadearArea>
      <ParameterArea>
        {modelRunGenerated && (
          <Notification
            kind={KIND.info}
            closeable
            overrides={{
              Body: {
                style: ({ $theme }) => {
                  return {
                    width: "95%",
                  };
                },
              },
            }}
          >
            {t("immutableRunNotification")}
          </Notification>
        )}
        <ModelerParametersView
          disabled={!modelRunId || modelRunGenerated}
          inputGroups={props.activeModeler?.inputGroups}
          inputValues={selectedModelRun?.inputValues}
          onInputValueChange={(groupName, itemName, itemValue) =>
            onInputValueChange(groupName, itemName, itemValue)
          }
        />
      </ParameterArea>
      <FooterArea>
        <FormControl id="model-run-notes" label={t("notesLabel")}>
          <Textarea
            id="model-run-notes-textarea"
            disabled={!modelRunId}
            value={modelRunNotes || ""}
            onChange={(e) => setModelRunNotes(e.target.value)}
            onBlur={(e) =>
              props.onselectedModelRunUpdate({ runNotes: modelRunNotes })
            }
            placeholder={t("notesPlaceholder")}
          />
        </FormControl>
      </FooterArea>
    </MainContainer>
  );
}
const mapStateToProps = (state) => {
  return {
    activeModelerId: state.modeler.activeModelerId,
    activeModeler: state.modeler.activeModeler,
    modelRuns: state.modelRun.modelRuns,
    selectedModelRun: state.modelRun.selectedModelRun,
    activeModelRunId: state.modelRun.selectedModelRunId,
    errors: state.modelRun.errors,
    createInProgress: state.modelRun.createInProgress,
    createSuccess: state.modelRun.createSuccess,
    createError: state.modelRun.createError,
    createErrorMessage: state.modelRun.createErrorMessage,
    fetchInProgress: state.modelRun.fetchInProgress,
    fetchError: state.modelRun.fetchError,
    fetchErrorMessage: state.modelRun.fetchErrorMessage,
    updateInProgress: state.modelRun.updateInProgress,
    updateError: state.modelRun.updateError,
    updateErrorMessage: state.modelRun.updateErrorMessage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchModelRunById: (modelRunId) => {
      dispatch(fetchModelRunById(modelRunId));
    },
    onselectedModelRunUpdate: (modelrun) => {
      dispatch(updateselectedModelRun({ modelrun }));
    },
    onSetselectedModelRun: (modelrun) => {
      dispatch(setselectedModelRun({ modelrun }));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModelerExecuteHomeView);
